import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { EmailComposer } from '@ionic-native/email-composer';

import { Camera } from '@ionic-native/camera';

import { MyApp } from './app.component';
//import { LoginPage } from '../pages/login/login';
//import { SignupPage } from '../pages/signup/signup';
//import { ConfirmPage } from '../pages/confirm/confirm';
//import { SettingsPage } from '../pages/settings/settings';
//import { AboutPage } from '../pages/about/about';
//import { AccountPage } from '../pages/account/account';
//import { TabsPage } from '../pages/tabs/tabs';
//import { TasksPage } from '../pages/tasks/tasks';
//import { TasksCreatePage } from '../pages/tasks-create/tasks-create';
//import { HomePage } from '../pages/home/home';
//import { ModelParametersPage } from '../pages/modelparameters/modelparameters';
//import { MapControlsPage } from '../pages/mapcontrols/mapcontrols';
//import { IncidentHistoryPage } from '../pages/incidenthistoy/incidenthistory';
//import { Tier2DetailsPage } from '../pages/tier2details/tier2details';
//import { ChangePwPage } from '../pages/change-pw/change-pw';
//import { ForgotPwPage } from '../pages/forgot-pw/forgot-pw';

import { GoogleAnalytics } from '@ionic-native/google-analytics';

import { Geolocation } from '@ionic-native/geolocation';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { User } from '../providers/providers';
import { Cognito } from '../providers/aws.cognito';
import { DynamoDB } from '../providers/aws.dynamodb';
//import { ModelParameters } from '../providers/model-parameters';

import { ImageZoomModule} from 'angular2-image-zoom';
import { ServerService, InterceptorModule } from '../service/index';
import { IotMessageService } from '../service/iot-message.service';
import { PrintProvider} from "../providers/print/print";


@NgModule({
  declarations: [
    MyApp,
    //LoginPage,
    //SignupPage,
    //ConfirmPage,
    //SettingsPage,
    //AboutPage,
    //AccountPage,
    //TabsPage,
    //TasksPage,
    //TasksCreatePage,
    //HomePage,
    //ModelParametersPage,
    //MapControlsPage,
    //Tier2DetailsPage,
    //IncidentHistoryPage,
    //ChangePwPage,
    //ForgotPwPage,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    //IonicModule.forRoot(MyApp),
    IonicModule.forRoot(MyApp, {
      preloadModules: true
    }),
    ImageZoomModule,
    InterceptorModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    //LoginPage,
    //SignupPage,
    //ConfirmPage,
    //SettingsPage,
    //AboutPage,
    //AccountPage,
    //TabsPage,
    //TasksPage,
    //TasksCreatePage,
    //HomePage,
    //ModelParametersPage,
    //MapControlsPage,
    //Tier2DetailsPage,
    //IncidentHistoryPage,
    //ChangePwPage,
    //ForgotPwPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    Camera,
    User,
    Cognito,
    DynamoDB,
    //ModelParameters,
    ServerService,
    IotMessageService,
    Geolocation,
    InAppBrowser,
    EmailComposer,
    PrintProvider,
    GoogleAnalytics,
  ]
})
export class AppModule {}

declare var AWS;
AWS.config.customUserAgent = AWS.config.customUserAgent + ' Ionic';



// WEBPACK FOOTER //
// ./src/app/app.module.ts